import PropTypes from 'prop-types';
import { NavLink as RouterLink, Link } from 'react-router-dom';
// @mui
import { Button, Box, List, ListItemText, Typography } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import styled from "@emotion/styled";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from 'react-router-dom';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import useDeleteSession from '../../hooks/KnowledgeAI/useDeleteSession';
import useGetSessionsInfo from '../../hooks/KnowledgeAI/useFetchSessions';
import ls from "localstorage-slim";
import { Tooltip } from '@mui/material';
// ----------------------------------------------------------------------

import SvgColor from '../svg-color';
import { useEffect, useState } from 'react';

NavSection.propTypes = {
  data: PropTypes.array,
};

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const StyledButton = styled(Button)({
  // fontFamily: "segoeui",
  lineHeight: 1,
  mt: "10px",
  mb: "10px",
  p: "16px 10px",

  borderRadius: "4px",
  // border: " 1.5px solid",
  width: "100%",
  height: "2rem",

  // "&:hover": {
  //   backgroundColor: "#fff",
  //   color: "#2962FF",
  // },
  "&.MuiButton-root": {
    padding: "16px 16px",
  },
});

export default function NavSection({ data = [], ...other }) {

  const [sessionIdL, setSessionIdL] = useState(0);
  const [chatSessionList, setChatSessionList] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  const { data: sessionHistory, loading: sessionHistoryLoading, fetchSessionsInfo: fetchSessionHistory } = useGetSessionsInfo();
  const { data: deleteSessionData, loading: deleteDataLoading, deleteSession } = useDeleteSession();

  const location = useLocation();

  useEffect(() => {
    const userdata = ls.get('token-gpt-app')
    const email = userdata.email.split('@')[0];
    setIsAdmin(userdata.isAdmin);
    fetchSessionHistory({
      "username": email,
      "app_name": process.env.REACT_APP_APP_NAME || "kai",
      "retrieve_type":"table",
      "fetch_all":"true"
    });
  }, []);
  // useEffect(() => {
  //   const userdata = ls.get('token-gpt-app')
  //   const email = userdata.email.split('@')[0];
  //   if (location.pathname.includes('/dashboard/chat')) {
  //     fetchSessionHistory({
  //       "username": email,
  //       "app_name": "tmap-portal",
  //       "retrieve_type":"table",
  //       "fetch_all":"true"
  //     });
  //   }
  // }, [location]);
  useEffect(() => {
    // console.log(sessionHistory);

    if (sessionHistoryLoading === false && sessionHistory !== undefined && sessionHistory !== null && sessionHistory.length > 0) {
      const currentTimestamp = Date.now();

      // Create a map to store the unique session_id objects
      const sessionMap = new Map();

      sessionHistory.forEach((session) => {
        const sessionId = session.session_id;
        const sessionTimestamp = new Date(session.createtimestamp).getTime();

        // Check if this session_id is already in the map
        if (sessionMap.has(sessionId)) {
          const existingSession = sessionMap.get(sessionId);
          const existingTimestamp = new Date(existingSession.createtimestamp).getTime();

          // Calculate the absolute difference in timestamps
          const currentDifference = Math.abs(currentTimestamp - sessionTimestamp);
          const existingDifference = Math.abs(currentTimestamp - existingTimestamp);

          // Replace if the new session is closer to the current timestamp
          if (currentDifference < existingDifference) {
            sessionMap.set(sessionId, session);
          }
        } else {
          // If session_id is not in the map, add it
          sessionMap.set(sessionId, session);
        }
      });

      // Convert the map values to an array
      // return Array.from(sessionMap.values

      // Find the session with the longest distance from the current timestamp
      let maxDistanceSession = null;
      let maxDistance = 0;

      sessionHistory.forEach((session) => {
        const sessionTimestamp = new Date(session.createtimestamp).getTime();
        const distance = Math.abs(currentTimestamp - sessionTimestamp);
        const sessionID = parseInt(session.session_id)
        if (distance > maxDistance) {
          sessionMap.set(session.session_id,
            {
              session_id: session.session_id,
              session_name: session.session_name,
              createtimestamp: sessionMap.get(session.session_id)?.createtimestamp
            }
          );
        }
        setSessionIdL(prevSessionIdL => {
          if (prevSessionIdL < sessionID) {
            return sessionID;
          } else {
            return prevSessionIdL;
          }
        });
      });

      // Sort the result array by createTimestamp
      const resultArray = Array.from(sessionMap.values());
      resultArray.sort((a, b) => new Date(b.createtimestamp).getTime() - new Date(a.createtimestamp).getTime());
      console.log(resultArray);
      setChatSessionList(resultArray);
    }
  }, [sessionHistoryLoading]);


  const StyledSessionButton = ({ session }) => {
    const [isSessionHover, setIsSessionHover] = useState(false);

    return (
      <Box
      // style = {{ background: '#4f758b', color:"#fff"}}
        onMouseEnter={() => {
          setIsSessionHover(true);
        }}
        onMouseLeave={() => {
          setIsSessionHover(false);
        }}>
        <StyledNavItem
          key={
            session.session_id + session.session_name
          }
          component={RouterLink}
          to={`/dashboard/chat/${session.session_id}`}
          sx={{
            '&.active': {
              color: 'text.primary',
              bgcolor: 'action.selected',
              fontWeight: 'fontWeightBold',
            },
          }}
        >
          <StyledNavItemIcon></StyledNavItemIcon>
          <ListItemText disableTypography primary={session.session_name} sx={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }} />
          {isSessionHover && <StyledNavItemIcon><Link to="/dashboard/chat/0"><DeleteOutlinedIcon
            onClick={() => {
              deleteSession({
                "user_id": "user0531",
                "session_id": session.session_id
              });
              setChatSessionList((prevChatSessionList) => {
                return prevChatSessionList.filter((chatSession) => {
                  return chatSession.session_id !== session.session_id;
                })
              })
            }}
          /></Link></StyledNavItemIcon>}
        </StyledNavItem>
      </Box>
    )
  }


  return (
    <Box {...other}>
      <List>
        {isAdmin && data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}

        <NavItem key={'Chat'} item={{
          title: 'Chat',
          path: '/dashboard/chat',
          
          icon: (
            <Tooltip title="Chat"  placement="right-start">
              {icon('ic_message')}
            </Tooltip>
          ),
        }} />
        {
          (sessionHistory !== undefined && sessionHistory !== null && sessionHistory.length > 0) && (
            <>
              <Box>
                {
                  chatSessionList.slice(0, 5).map((session) => (
                    <StyledSessionButton session={session} key={
                      session.session_id + session.session_name
                    }/>
                  ))
                }
              </Box>
            </>
          )
        }
      </List>

    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.contrastText',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
